
if (typeof window !== 'undefined') {
  // Monitor for aria-hidden being added to root
  const rootElement = document.getElementById('root');
  
  if (rootElement) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          // Remove aria-hidden from root when modal is open
          if (rootElement.getAttribute('aria-hidden') === 'true') {
            console.log('⚠️ Removing aria-hidden from root element');
            rootElement.removeAttribute('aria-hidden');
          }
        }
      });
    });
    
    observer.observe(rootElement, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
    
    console.log('✅ Monitoring root element for aria-hidden');
  }
}